import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getAssignmentSummary } from 'components/nutrition/assignmentLabel';

/**
 * Chip con el DESTINO de un programa o recetario: "Todos", "Plan: Active Plus", el nombre del
 * cliente, o "Sin asignar".
 *
 * Sustituye al chip que mostraba el campo `type` (General / Específico) y que se confundía con la
 * asignación. Se usa igual en la card del admin y en la vista del cliente para que ambos lean lo
 * mismo. Sin asignaciones va en gris, no en dorado: el dorado es acento y aquí lo que hay es una
 * advertencia de que ese contenido no le llega a nadie.
 */
function AssignmentChip({ assignments = [], size = 'small' }) {
  const { t } = useTranslation(['nutrition']);
  const { label, extra, tone } = getAssignmentSummary(assignments, t);

  const isGold = tone === 'gold';

  return (
    <Chip
      size={size}
      label={extra > 0 ? `${label} +${extra}` : label}
      sx={{
        maxWidth: '100%',
        fontWeight: 700,
        backgroundColor: isGold ? 'gold.soft' : 'surface.overlay',
        color: isGold ? 'gold.main' : 'text.secondary'
      }}
    />
  );
}

AssignmentChip.propTypes = {
  assignments: PropTypes.array,
  size: PropTypes.string
};

export default AssignmentChip;
